import { render } from "./turmas_do_professor.vue?vue&type=template&id=9e2519e0&scoped=true"
import script from "./turmas_do_professor.vue?vue&type=script&lang=js"
export * from "./turmas_do_professor.vue?vue&type=script&lang=js"

import "./turmas_do_professor.vue?vue&type=style&index=0&id=9e2519e0&lang=scss&scoped=true"
import "./turmas_do_professor.vue?vue&type=style&index=1&id=9e2519e0&lang=css"
import "./turmas_do_professor.vue?vue&type=style&index=2&id=9e2519e0&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e2519e0"]])

export default __exports__